/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 */

/**
 * Active eTextbook access checkmark (20x17).
 *
 * @file RosterAccessActiveIcon.jsx
 * @author Anuja Gaikwad
 * @since 2.3.5
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function RosterAccessActiveIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 17">
      <path
        d="M6.14537 17C5.72562 17 5.38981 16.8334 5.13796 16.5001L0.268762 10.5843C-0.150996 10.0844 -0.0670446 9.25118 0.436665 8.83458C0.940375 8.41797 1.77989 8.5013 2.19965 9.00122L6.06142 13.7505L17.8146 0.419195C18.2344 -0.0807288 19.0739 -0.164049 19.5776 0.335874C20.0813 0.835798 20.1653 1.58568 19.6616 2.08561L7.06884 16.5834C6.81699 16.9167 6.48118 17 6.14537 17Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default RosterAccessActiveIcon;
